// extracted by mini-css-extract-plugin
module.exports = {"ReadMoreText":"styles_ReadMoreText__4JKeQ","textItem":"styles_textItem__DJgVF"};